import { FormControl, Grid, InputLabel, Select, TextField, Typography, Box } from '@mui/material';
import api from "../services/api";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, setValidationMessage, activeValidations
    , setListTipos, setListClases, setListEstados } from "../redux/puntuacionSlice";
import { FormHelperText as HelperText } from '@mui/material';

const Puntuacion = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.puntuacion.entity);
    const defaultEntity = useSelector((state) => state.puntuacion.defaultEntity);
    const listTipos = useSelector((state) => state.puntuacion.listTipos);
    const listClases = useSelector((state) => state.puntuacion.listClases);
    const listEstados = useSelector((state) => state.puntuacion.listEstados);
    const validate = useSelector((state) => state.puntuacion.validationActive);
    const dispatch = useDispatch();
    const fechaIngresoMinimo = new Date(2010, 1, 1);

    var validation = {
        codigo: {
            error: entity.codigo == null || entity.codigo.trim().length < 1,
            message: "Falta ingresar el codigo",
        },
        nombre: {
            error: entity.nombre == null || entity.nombre.trim().length < 1,
            message: "Falta ingresar el nombre",
        },
        idTipo: {
            error: entity.idTipo == null || entity.idTipo == 0,
            message: "Falta ingresar el tipo",
        },
        idClase: {
            error: entity.idClase == null || entity.idClase == 0,
            message: "Falta ingresar la clase",
        },
        idEstado: {
            error: entity.idEstado == null || entity.idEstado == 0,
            message: "Falta ingresar el estado",
        },
    }

    const fetchEntity = useCallback(async () => {
        if (parseInt(params.id || "0") <= 0) {
            dispatch(setEntity(defaultEntity));
            return;
        }

        await api.get("/Puntuacion/GetsPuntuacionView")
            .then((response) => {
                const encontrado = (response.data?.data || []).find((row) => row.id == params.id);

                if (encontrado == null) {
                    dispatch(setEntity(defaultEntity));
                }
                else {
                    dispatch(setEntity(encontrado));
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }, [])

    const fetchListTipos = useCallback(async () => {
        // Catalogo 62: Numerico, Letras, Alfanumerico.
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=62")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListTipos(response?.data?.data || []));
    }, [])

    const fetchListClases = useCallback(async () => {
        // Catalogo 320: Clases de puntuacion -> Sesiones de terapia (321) y
        // Planificacion de terapia (322). Define en que listado del plan va
        // a aparecer la escala.
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=320")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListClases(response?.data?.data || []));
    }, [])

    const fetchListEstados = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=1")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListEstados(response?.data?.data || []));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchListTipos();
        fetchListClases();
        fetchListEstados();
        dispatch(setValidationMessage(messagesValidation()));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage(messagesValidation()));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData(e.target));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.codigo && validation.codigo.error}>
                        <TextField
                            name="codigo"
                            label="Codigo"
                            fullWidth
                            value={entity.codigo}
                            onChange={setDataEntity}
                            error={validate.codigo && validation.codigo.error}
                            helperText={validate.codigo && validation.codigo.error ? validation.codigo.message : ""}
                            disabled={isReadOnly}
                            size="small"
                            inputProps={{ maxLength: 10 }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <FormControl required fullWidth error={validate.nombre && validation.nombre.error}>
                        <TextField
                            name="nombre"
                            label="Nombre"
                            fullWidth
                            value={entity.nombre}
                            onChange={setDataEntity}
                            error={validate.nombre && validation.nombre.error}
                            helperText={validate.nombre && validation.nombre.error ? validation.nombre.message : ""}
                            disabled={isReadOnly}
                            size="small"
                            inputProps={{ maxLength: 80 }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={4}>
                    <FormControl required fullWidth error={validate.idTipo && validation.idTipo.error}>
                        <InputLabel htmlFor="input-tipo">Tipo</InputLabel>
                        <Select
                            native
                            label="Tipo"
                            value={entity.idTipo}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idTipo',
                                id: 'input-tipo',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listTipos.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idTipo && validation.idTipo.error ? validation.idTipo.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.idClase && validation.idClase.error}>
                        <InputLabel htmlFor="input-clase">Clase</InputLabel>
                        <Select
                            native
                            label="Clase"
                            value={entity.idClase}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idClase',
                                id: 'input-clase',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listClases.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idClase && validation.idClase.error ? validation.idClase.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        name="valorMinimo"
                        label="Valor Minimo"
                        type="number"
                        fullWidth
                        value={entity.valorMinimo == null ? "" : entity.valorMinimo}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        name="valorMaximo"
                        label="Valor Maximo"
                        type="number"
                        fullWidth
                        value={entity.valorMaximo == null ? "" : entity.valorMaximo}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.idEstado && validation.idEstado.error}>
                        <InputLabel htmlFor="input-estado">Estado</InputLabel>
                        <Select
                            native
                            label="Estado"
                            value={entity.idEstado}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idEstado',
                                id: 'input-estado',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listEstados.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idEstado && validation.idEstado.error ? validation.idEstado.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    );
}
export default Puntuacion;